// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1XQxU","select":"Header_select__7s_XX","clinic":"Header_clinic__tZ8Qj"};